import TraceInit from '../TraceInit';
import AdapterConfig from '../utils/AdapterConfig';
export default class Exposure {
  /**
   * 曝光初始化
   * @param {*} area 曝光的area值，每个模块area不同，根据统计需要来传入
   * @param {*} hadExposureList： 存储已经曝光过的item
   * @param {*} viewableItemsArr：可视的item集合
   */
  constructor(statSend) {
    this.hadExposureList = [];
    this.viewableItemsArr = [];
    this.statSend = statSend;
  }

  /**
   * 实时计算曝光数据
   * @param {*} info itemChange
   */
  computed(info) {
    const itemChangeData = info.ins;
    // 存储现在可视区域的items

    this.viewableItemsArr = info.visible;
    // 需要上报的items
    itemChangeData.forEach((item) => {
      // 曝光不再做去重
      this.exposureSend(item);

      // 给每个要曝光的数据，生成唯一的一个key值，并记录下来
      // const uniqueKey = this.getIDFromSpm(item);
      // if (this.hadExposureList.indexOf(uniqueKey) < 0) {
      //   this.exposureSend(item);
      //   this.hadExposureList.push(uniqueKey);
      // }
    });
  }

  getSpmValue(element) {
    const param = {
      b: element.b || element.page || this.navigatorName,
      c: element.c || element.area,
      d: element.d || element.index + 1,
    };
    return AdapterConfig.getSpm(this.statSend, param);
  }

  /**
   * 触发上报
   * @param {*} str 曝光参数
   */
  // const { iid: str, spm, page, scmv2 = '', area = '', extra } = item;
  exposureSend(item) {
    // 兼容性处理
    if (!TraceInit.getInstance().isSpm) {
      this.statSend.visible(item);
      return;
    }

    // 原来SPM的逻辑 对getParse得到的数据进行解析上报
    const { b, c, area, scmv2 = '', iid, key, extra = {} } = item;
    const str = iid || key;

    if (!str || str === '') {
      return;
    }

    const _area = c || area || '';
    const page = b || this.changeNaviagtorNameToPageName(this.navigatorName) || '';
    let spm = '';
    if (str != '') {
      spm = this.getSpmValue(item);
    }

    const reg = /\{(.*?)\}/g;
    let exposureIid = str;

    try {
      exposureIid = ''.replace(reg, str) || str;
    } catch (error) {
      console.log(error);
    }

    const _scmv2 = scmv2 || this.scmv2 || '';
    const jsonObj = {
      spm,
      scmv2: _scmv2,
      last_scmv2: this.last_scmv2,
      scmv2_num: this.scmv2_num,
      ...extra,
    };

    if (page) {
      jsonObj.pageName = page;
      jsonObj.page = page;
    }
    this.statSend.visible(_area, exposureIid, jsonObj);
  }

  leave() {}

  getIDFromSpm(item) {
    if (item.key || item.iid) {
      return `${item?.key || item?.iid}_${item?.c}_${item?.d}`;
    }
    return 'default';
  }

  back() {
    if (!this.viewableItemsArr) {
      return;
    }
    this.hadExposureList = [];
    for (let i = 0; i < this.viewableItemsArr.length; ++i) {
      this.exposureSend(this.viewableItemsArr[i]);
      // this.hadExposureList.push(this.getIDFromSpm(this.viewableItemsArr[i]));
    }
  }

  close() {
    this.viewableItemsArr = [];
    this.hadExposureList = [];
  }

  changeNaviagtorNameToPageName(navigatorName) {
    if (!navigatorName || typeof navigatorName !== 'string' || navigatorName.length <= 0) {
      return '';
    }
    const tNavigatorName = navigatorName;
    let pageName = navigatorName.replace(/\$/g, '');
    if (tNavigatorName && tNavigatorName.indexOf('$') === 0) {
      try {
        pageName = tNavigatorName.match(/\$(\S*)\$/)[1];
      } catch (error) {
        console.log('changeNaviagtorNameToPageName Error:', error);
      }
    }
    return pageName;
  }
}
